import React from 'react';
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import Maxcologo from './maxcologo.png';

const InvoiceComponent = () => {
    return (
        <Container
            style={{
                fontFamily: "Quicksand",
            }}
        >
            <Row style={{ alignItems: 'center' }}>
                <Col>
                    <img src={Maxcologo} alt="coverimg" style={{ width: '40%' }} />
                </Col>
                <Col>
                    <h6 className="text-end" style={{ fontWeight: 700 }}>Invoice no.: INV-045</h6>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <h5 className="text-center">TAX INVOICE</h5>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <p className='mb-0'>
                        <strong>Order no #585</strong>
                    </p>
                    <p className='mb-0'><strong>Bill To:</strong></p>
                    <p className='mb-0'>Akhil Nayak</p>
                    <p className='mb-0'>9999887776</p>
                    <p className='mb-0'>akhilnayak@gmail.com</p>
                </Col>
                <Col className="text-end">
                    <p><strong>Date:</strong> 13/12/24</p>
                </Col>
            </Row>
            <Table bordered style={{ borderRadius: '15px', overflow: 'hidden' }}>
                <thead>
                    <tr>
                        <th style={{ fontSize: '14px', padding: '6px' }}>Description</th>
                        <th style={{ fontSize: '14px', padding: '6px' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '14px', padding: '6px' }}>1 Year Basic Plan</td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 3650</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Premium Domain</td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 800</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '14px', padding: '6px' }}>AI Marketing</td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 1825</td>
                    </tr>
                    <tr>
                        <td className='text-end' style={{ fontSize: '14px', padding: '6px' }}>
                            <strong>Sub Total</strong>
                        </td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 6,275</td>
                    </tr>
                    <tr>
                        <td className='text-end' style={{ fontSize: '14px', padding: '6px' }}>Taxable Amount</td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 5,317.8</td>
                    </tr>
                    <tr>
                        <td className='text-end' style={{ fontSize: '14px', padding: '6px' }}>GST 18%</td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>Rs 957.2</td>
                    </tr>
                    <tr>
                        <td className='text-end' style={{ fontSize: '14px', padding: '6px' }}>
                            <strong>Total Amount</strong>
                        </td>
                        <td style={{ fontSize: '14px', padding: '6px' }}>
                            <strong>Rs 6,275</strong>
                        </td>
                    </tr>
                </tbody>
            </Table>
            <Row>
                <Col>
                    <p><strong>Plan Validity:</strong> 1 year from the date of Publish</p>
                </Col>
            </Row>
        </Container>
    );
};

export default InvoiceComponent;
